export const CLIENT_ADULT = 'Cам клиент - взрослый';
export const CLIENT_CHILD = 'Cам клиент - ребенок';
export const PARENT = 'Родитель / родители';
export const CLOSE_CARING_ADULT = 'Близкий ухаживающий взрослый';

export enum SpokesmanType {
	CLIENT_ADULT = 'CLIENT_ADULT',
	CLIENT_CHILD = 'CLIENT_CHILD',
	PARENT = 'PARENT',
	CLOSE_CARING_ADULT = 'CLOSE_CARING_ADULT',
}

export const getSpokesmanTypeText = (value?: SpokesmanType | string) => {
	switch (value) {
		case SpokesmanType.CLIENT_ADULT:
			return CLIENT_ADULT;
		case SpokesmanType.CLIENT_CHILD:
			return CLIENT_CHILD;
		case SpokesmanType.PARENT:
			return PARENT;
		case SpokesmanType.CLOSE_CARING_ADULT:
			return CLOSE_CARING_ADULT;
		default:
			return value;
	}
};
